import { render } from "./MbIndexThumbnailDisp.vue?vue&type=template&id=25f076ce"
import script from "./MbIndexThumbnailDisp.vue?vue&type=script&lang=js"
export * from "./MbIndexThumbnailDisp.vue?vue&type=script&lang=js"

import "./MbIndexThumbnailDisp.vue?vue&type=style&index=0&id=25f076ce&lang=scss"
script.render = render

export default script